import locale from "common/managers/locale";
import DFButton from "app/widgets/DFButton/DFButton";

export default {

    _prepareAddButton() {
        const button = $("<button></button>", {
            "class": "add",
            "text": locale.get(this.options.addButtons.add)
        });
        button.insertAfter(this.wrapper);
        this.addButton = new DFButton(button, {});
        this.addButton.bind("click", () => {
            const item = this.dataSource.add({});
            this.editRow(this.tbody.find(`[data-uid="${item.uid}"]`));
        });
        this.bind("edit", () => {
            this.addButton.enable(false);
        });
        const done = () => {
            this.addButton.enable(true);
        };
        this.bind("save", done);
        this.bind("cancel", done);
    },

    _updateAddButton() {
        if(this.options.addButtons && !this.addButton) {
            this._prepareAddButton();
        }
        if(this.options.addButtons) {
            if(this.dataSource.view().length === 0 && this.options.addButtons.addFirst) {
                this.addButton.element.text(locale.get(this.options.addButtons.addFirst));
                this.wrapper.hide();
            } else {
                this.addButton.element.text(locale.get(this.options.addButtons.add));
                this.wrapper.show();
            }
        }
    },

    _cleanupAddButton() {
        if(this.addButton) {
            this.addButton.destroy();
            this.addButton.unbind();
            this.addButton.element.remove();
            delete this.addButton;
        }
    }
}
